export const ACTIVITY_FILTERS = {
  search: '',
  dateRange: {
    startDate: '',
    endDate: ''
  },
  attributes: '',
  tags: ''
};
